import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import Picture from "/components/core/picture/picture-component";
import CheckListChecked from "/static/svg/checklist_checked.svg";
import CheckListEmpty from "/static/svg/checklist_empty.svg";
import { componentStyles } from "./cluster-option-component.scss";
class ClusterOptionComponent extends PureComponent {
    onSelect() {
        const { selectCallback, option } = this.props;
        selectCallback(option.id);
    }
    render() {
        const { selected, singleImage, option, showCheckboxIcon } = this.props;
        const image = singleImage && option.detailsImage ? option.detailsImage : option.image;
        const text = singleImage && option.detailsText ? option.detailsText : option.text;
        const ChecklistComponent = singleImage ? CheckListChecked : CheckListEmpty;
        return /*#__PURE__*/ _jsxs("div", {
            onMouseDown: this.onSelect,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("cluster-manage-option", {
                selected: selected,
                "big-image": singleImage
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "cluster-image-wrapper",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: image,
                        className: `jsx-${componentStyles.__hash}` + " " + "cluster-option-image"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("cluster-text-wrapper", {
                        "with-checkbox": showCheckboxIcon
                    }) || ""),
                    children: [
                        showCheckboxIcon && /*#__PURE__*/ _jsx(ChecklistComponent, {
                            className: `jsx-${componentStyles.__hash}`
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + (classnames("cluster-option-text", {
                                "is-other": option.detailsText
                            }) || ""),
                            children: [
                                " ",
                                text
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onSelect = this.onSelect.bind(this);
    }
}
export { ClusterOptionComponent as default };
